export type EvvCaptureState =
  | 'not_started'
  | 'clocked_in'
  | 'clocked_out'
  | 'partial'
  | 'complete';

/**
 * Evv Capture State
 */
/**
 * Array of all EvvCaptureState values.
 * Evv Capture State
 */
export const EVVCAPTURESTATE_VALUES: readonly EvvCaptureState[] = [
  'not_started',
  'clocked_in',
  'clocked_out',
  'partial',
  'complete',
] as const;
